<template>
  <div class="content-main">
    <div class="content" style="width: 100%">
      <div class="header flex justify-between items-center">
        <span>Departamentos</span>
      </div>

      <div class="mb-4 px-4">
        <input
          v-model="search"
          type="text"
          class="w-full border rounded px-3 py-2"
          placeholder="Search by code, name..."
          @input="page = 1"
        />
      </div>

      <div class="table">
        <table class="default-table" v-if="!loading">
          <thead>
            <tr class="table100-head">
              <th>ID</th>
              <th>Código</th>
              <th>Nombre</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="dept in paginatedDepartments" :key="dept.departamentoId">
              <td>{{ dept.departamentoId }}</td>
              <td>{{ dept.codigo || "-" }}</td>
              <td>{{ dept.nombre || "-" }}</td>
            </tr>
            <tr v-if="filteredDepartments.length === 0">
              <td colspan="3" class="text-center text-gray-500 py-4">
                No departments found
              </td>
            </tr>
          </tbody>
        </table>
        <div v-else class="p-8 text-center">Loading...</div>
      </div>

      <div class="footer">
        <div class="totals">
          showing {{ perPage * (page - 1) + 1 }} to
          {{ Math.min(perPage * page, filteredDepartments.length) }} from
          {{ filteredDepartments.length }} results
        </div>
        <div class="pages">
          <select v-model="perPage" @change="page = 1">
            <option :value="20">20</option>
            <option :value="50">50</option>
            <option :value="100">100</option>
          </select>
          Per Page
        </div>
        <div class="pages">
          <a
            class="page-link"
            :class="{ disabled: page <= 1 }"
            @click="previous"
          >
            Previous
          </a>
          <span>Page {{ page }}</span>
          <a
            class="page-link"
            :class="{ disabled: page >= totalPages }"
            @click="next"
          >
            Next
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDepartamentos } from "@/api/Infoauto.js";

export default {
  name: "DepartmentsPage",
  data() {
    return {
      departments: [],
      loading: false,
      search: "",
      page: 1,
      perPage: 20
    };
  },
  computed: {
    filteredDepartments() {
      if (!this.search) return this.departments;
      const q = this.search.toLowerCase();
      return this.departments.filter(
        d =>
          (d.codigo || "").toLowerCase().includes(q) ||
          (d.nombre || "").toLowerCase().includes(q)
      );
    },
    totalPages() {
      return Math.ceil(this.filteredDepartments.length / this.perPage) || 1;
    },
    paginatedDepartments() {
      const start = (this.page - 1) * this.perPage;
      return this.filteredDepartments.slice(start, start + this.perPage);
    }
  },
  mounted() {
    this.loadDepartments();
  },
  methods: {
    async loadDepartments() {
      this.loading = true;
      try {
        const data = await getDepartamentos();
        this.departments = data || [];
      } finally {
        this.loading = false;
      }
    },
    previous() {
      if (this.page > 1) this.page--;
    },
    next() {
      if (this.page < this.totalPages) this.page++;
    }
  }
};
</script>
